export default __webpack_public_path__ + "static/media/teatsad.340530a1.jpg";